import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronDownIcon } from 'lucide-react';
const TESTIMONIALS = [{
  result: '-15 cm',
  quote: 'Me sentí más liviana en pocas semanas. Bajó la hinchazón de la tarde y dejé de llegar a la noche con antojos.',
  name: 'Carmen M.',
  age: '44 años',
  country: 'México'
}, {
  result: '-12 cm',
  quote: 'Volví a tener energía sin vivir a café y fuerza de voluntad. Noté cambios reales en la cintura.',
  name: 'Sofía R.',
  age: '39 años',
  country: 'Colombia'
}, {
  result: '-14 cm',
  quote: 'Necesitaba algo simple que pudiera sostener. Me desinflamé y volví a notar cambios reales en la ropa.',
  name: 'Ana L.',
  age: '47 años',
  country: 'Argentina'
}];
function TestimonialCard({
  t,
  index
}: {
  t: (typeof TESTIMONIALS)[number];
  index: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.2
  }} className="card-premium p-6 md:p-8 relative hover:border-gold/40 transition-colors duration-300 mt-4 md:mt-0" data-id="element-383" data-mp="2yd37uz1zttfu">
      <div className="space-y-6" data-id="element-384" data-mp="2q0n8g8am99so">
        {/* Stars */}
        <div className="flex gap-1" data-id="element-385" data-mp="34q2p2vgfnyun">
          {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 text-secondary fill-secondary" data-id="element-386" data-mp="2zrregiibdkbd" data-mpi={j} />)}
        </div>

        {/* Quote */}
        <p className="text-foreground/90 font-body font-medium italic text-base md:text-lg leading-relaxed" data-id="element-387" data-mp="2c3rovlwqnzyd">
          "{t.quote}"
        </p>

        {/* Author Info */}
        <div className="pt-4 border-t border-border/50" data-id="element-388" data-mp="2m0mne4t0i0cn">
          <p className="font-display font-bold text-lg text-gold-light" data-id="element-389" data-mp="2m27hxufbtjai">
            {t.name}
          </p>
          <p className="text-sm text-foreground/60 font-body mt-1" data-id="element-390" data-mp="2h3w65e5h0ypn">
            {t.age} • {t.country}
          </p>
        </div>
      </div>
    </motion.div>;
}
export function TestimonialsSection() {
  const [expanded, setExpanded] = useState(false);
  const visible = TESTIMONIALS.slice(0, 2);
  const hidden = TESTIMONIALS.slice(2);
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-391" data-mp="8dc53xfoabf8">
      <div className="max-w-[1400px] mx-auto space-y-16" data-id="element-392" data-mp="8foiryeedzmh">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-393" data-mp="davikv4jqk64">
          <p className="text-secondary font-bold uppercase tracking-wider text-sm" data-id="element-394" data-mp="3gru7biixmwqx">
            Lo que cuentan mujeres que hicieron H.E.R.
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-black" data-id="element-395" data-mp="3qqth54ffoyfi">
            Resultados <span className="text-gradient-gold" data-id="element-396" data-mp="3vj30u2pyh29c">Reales</span>
          </h2>

          {/* Rating social proof */}
          <div className="flex flex-col items-center gap-2 pt-2" data-id="element-397" data-mp="2y24g15edot3r">
            <div className="flex items-center gap-1" role="img" aria-label="Calificación 4.9 de 5 estrellas" data-id="element-398" data-mp="3320ih07fgch7">
              {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 text-secondary fill-secondary" data-id="element-399" data-mp="1k5uq32zkbu84" data-mpi={j} />)}
            </div>
            <p className="font-body text-foreground/70 text-[15px] md:text-base" data-id="element-400" data-mp="1g6vjzf23hrf3">
              <span className="font-semibold text-gold-light" data-id="element-401" data-mp="1b5eo5xygwv5d">4.9/5</span>{' '}
              basado en mujeres que completaron H.E.R.
            </p>
          </div>
        </motion.div>

        {/* Testimonials — sin carrusel, scroll natural */}
        <div className="max-w-6xl mx-auto" data-id="element-402" data-mp="11ae9eq1qcgtl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-403" data-mp="whbeoel7v1bt">
            {visible.map((t, i) => <TestimonialCard key={i} t={t} index={i} data-id="element-404" data-mp="sfghnmabja3u" data-mpi={i} />)}
          </div>

          <AnimatePresence initial={false} data-id="element-405" data-mp="sdlxia6vfm0t">
            {expanded && <motion.div key="hidden-testimonials" initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.28,
            ease: 'easeOut'
          }} className="overflow-hidden" data-id="element-406" data-mp="ni6llnsfc071">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-407" data-mp="2ikbblbf8spv0">
                  {hidden.map((t, i) => <TestimonialCard key={i} t={t} index={i} data-id="element-408" data-mp="23vx9j2pnh5fi" data-mpi={i} />)}
                </div>
              </motion.div>}
          </AnimatePresence>

          <div className="mt-10 flex justify-center" data-id="element-409" data-mp="28sfdw1h2j1rb">
            <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} className="group inline-flex items-center gap-2 font-body uppercase tracking-[0.18em] text-[13px] text-[#C8A870] hover:text-[#E8D5B0] transition-colors duration-300 focus:outline-none" data-id="element-410" data-mp="1uu7jo1bf2eju">
              {expanded ? 'Ver menos experiencias' : 'Ver más experiencias'}
              <motion.span animate={{
              rotate: expanded ? 180 : 0
            }} transition={{
              duration: 0.28,
              ease: 'easeOut'
            }} className="inline-flex" data-id="element-411" data-mp="1px7cto6qt7ro">
                <ChevronDownIcon className="w-4 h-4" data-id="element-412" data-mp="18m1t9livlsi1" />
              </motion.span>
            </button>
          </div>
        </div>
      </div>
    </section>;
}